interface Props {
  kind: 'loading' | 'empty' | 'error'
  message: string
  /** Dev-only technical text from the API; hidden behind a disclosure. */
  detail?: string | null
  onRetry?: () => void
}

/** One place for the loading, empty and error panes, so no screen ever renders blank. */
export default function StateBlock({ kind, message, detail, onRetry }: Props) {
  return (
    <div className={kind === 'error' ? 'state error' : 'state'} role={kind === 'error' ? 'alert' : 'status'}>
      {kind === 'loading' && <span className="spinner" aria-hidden="true" />} {message}
      {detail && (
        <details>
          <summary>Technische details</summary>
          <pre>{detail}</pre>
        </details>
      )}
      {onRetry && (
        <div>
          <button type="button" className="btn" onClick={onRetry}>
            Opnieuw proberen
          </button>
        </div>
      )}
    </div>
  )
}
